import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/system'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import Image from '@/assets/images/welcome.svg?react'
import { LoginButton } from '@/modules/auth/components/LoginButton.tsx'

import messages from './messages'

const containerSx: SxProps<Theme> = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  flex: '1 0 100%',
  paddingTop: 4,
  paddingBottom: 4,
  [theme.breakpoints.up('md')]: {
    padding: 4,
  },
})

const stackSx: SxProps<Theme> = (theme) => ({
  flexDirection: 'column-reverse',
  alignItems: 'center',
  gap: 2,
  minWidth: 0,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'initial',
    gap: 4,
  },
})

const titleSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.common.black,
})

const contentBoxSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.customGrey.darker,
  minWidth: '300px',
  flex: '1 1 0',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 1.5,
})

const loginBtnSx = {
  minWidth: '140px',
}

const imageBoxSx: SxProps<Theme> = (theme) => ({
  flex: '1 1 0',
  maxWidth: '414px',
  [theme.breakpoints.up('md')]: {
    paddingTop: 4.5,
  },
  ['svg']: {
    maxWidth: '100%',
    height: 'auto',
  },
})

const imageNoteSx: SxProps<Theme> = (theme) => ({
  padding: theme.spacing(0.75, 2),
})

const linkNoteSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.customGrey.light,
  textDecoration: 'none',
  transition: 'color .3s',
  ['&:hover']: {
    color: theme.palette.customGrey.dark,
  },
})

const imageLink1 =
  'https://de.freepik.com/vektoren-kostenlos/ein-alter-mann-hoert-das-konzept-der-radio-illustration_144643142.htm#fromView=search&page=1&position=35&uuid=d794322a-d249-458b-a673-c9b37f0576aa'
const imageLink2 =
  'https://de.freepik.com/vektoren-kostenlos/frau-die-riesigen-checklistenhintergrund-ueberprueft_4059814.htm#query=kontrolle&position=40&from_view=keyword&track=ais_user_b&uuid=41f82426-729f-4fac-b78c-ca7ad68029b7'

export const LoginPage = () => {
  const { formatMessage } = useIntl()

  return (
    <Container maxWidth="lg" sx={containerSx}>
      <Stack sx={stackSx}>
        <Stack sx={contentBoxSx}>
          <Typography variant="h2" component="h1" sx={titleSx}>
            {formatMessage(messages.welcomeTitle)}
          </Typography>
          <Typography variant="h5" component="p" fontWeight="medium">
            {formatMessage(messages.welcomeText)}
          </Typography>
          <Typography fontWeight="normal">
            {formatMessage(messages.welcomeNote)}
          </Typography>
          <LoginButton sx={loginBtnSx} />
        </Stack>
        <Box sx={imageBoxSx}>
          <Image />
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={imageNoteSx}
          >
            <Typography
              variant="overline"
              fontWeight="normal"
              component={Link}
              to={imageLink1}
              sx={linkNoteSx}
            >
              {formatMessage(messages.imageCopyright1)}
            </Typography>
            <Typography
              variant="overline"
              fontWeight="normal"
              component={Link}
              to={imageLink2}
              sx={linkNoteSx}
            >
              {formatMessage(messages.imageCopyright2)}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Container>
  )
}
